module.exports = __webpack_public_path__ + "img/feature_buy_ko.5bbfdee6.png";